.container {
	margin: 1rem;
	border-radius: 6px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
	overflow: hidden;
	border-left: 3px solid;
	animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
	from {
		opacity: 0;
		transform: translateY(-8px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.info {
	border-left-color: #3b82f6;
	background-color: #eff6ff;
}

.warning {
	border-left-color: #f59e0b;
	background-color: #fffbeb;
}

.error {
	border-left-color: #ef4444;
	background-color: #fef2f2;
}

.success {
	border-left-color: #10b981;
	background-color: #f0fdf4;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.625rem 0.875rem;
	background-color: rgba(255, 255, 255, 0.6);
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.iconTitle {
	display: flex;
	align-items: center;
	gap: 0.5rem;
}

.icon {
	width: 18px;
	height: 18px;
}

.info .icon {
	color: #2563eb;
}

.warning .icon {
	color: #d97706;
}

.error .icon {
	color: #dc2626;
}

.success .icon {
	color: #059669;
}

.title {
	font-weight: 600;
	font-size: 0.8125rem;
	color: #1e293b;
}

.closeButton {
	background: none;
	border: none;
	cursor: pointer;
	padding: 0.25rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	transition: background-color 0.2s;
	color: #64748b;

	&:hover {
		background-color: rgba(0, 0, 0, 0.08);
		color: #1e293b;
	}
}

.messagesContainer {
	padding: 0.625rem 0.875rem;
	display: flex;
	flex-direction: column;
	gap: 0.375rem;
	max-height: 200px;
	overflow-y: auto;
}

.message {
	padding: 0.5rem;
	background-color: rgba(255, 255, 255, 0.5);
	border-radius: 4px;
	animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

.messageText {
	font-size: 0.8125rem;
	line-height: 1.4;
	color: #334155;
}

.progressBar {
	height: 2px;
	background-color: rgba(0, 0, 0, 0.08);
	overflow: hidden;
}

.progressFill {
	height: 100%;
	transition: width 0.1s linear;
}

.info .progressFill {
	background-color: #3b82f6;
}

.warning .progressFill {
	background-color: #f59e0b;
}

.error .progressFill {
	background-color: #ef4444;
}

.success .progressFill {
	background-color: #10b981;
}

.messagesContainer::-webkit-scrollbar {
	width: 5px;
}

.messagesContainer::-webkit-scrollbar-track {
	background: rgba(0, 0, 0, 0.04);
	border-radius: 3px;
}

.messagesContainer::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, 0.15);
	border-radius: 3px;
}

.messagesContainer::-webkit-scrollbar-thumb:hover {
	background: rgba(0, 0, 0, 0.25);
}
